import { apiGet, apiPost } from './index'

// 答题统计
const dailyStatistics = (params) => apiGet('/api/question/daily/statistics', params)
// 是否需要一键推荐提醒
const dailyQuestionRemind = (params) => apiGet(`/api/johnson/iep/users/dailyQuestionRemind/status/${params.userId}`, params)
// 开启一键推荐提醒
const updateDailyQuestionRemind = (params) => apiPost(`/api/johnson/iep/users/dailyQuestionRemind/${params.userId}/${params.dailyQuestionRemind}`, params)
// 每日一题弹窗提醒
const dailyRead = (params) => apiGet(`/api/question/message/user/read/${params.userId}/${params.readType}`, params)
// 每日一题弹窗提醒
const postDailyRead = (params) => apiPost(`/api/question/message/user/read`, params)
// 病种筛选列表
const getEffective = (params) => apiGet(`/api/question/class/effective`, params)
// 等级筛选列表
const getLevel = (params) => apiGet(`/api/question/difficulty/level`, params)
// 题库分类列表
const getBankList = (params) => apiGet(`/api/question/user/bank/class`, params)
// 题库题目列表
const getTopicList = (params) => apiGet(`/api/question/user/bank/topic`, params)
// 题目收藏分类列表
const getCollectBankList = (params) => apiGet(`/api/question/user/collect/class`, params)
// 题目收藏分类列表
const getCollectTopicList = (params) => apiGet(`/api//question/user/collect`, params)
// 用户错题分类分页列表
const getErrBankList = (params) => apiGet(`/api/question/user/result/wrong/class`, params)
// 用户错题分页列表
const getErrTopicList = (params) => apiGet(`/api/question/user/result/wrong`, params)
// 删除用户错题数量
const delWrong = (params) => apiPost(`/api/question/user/result/update/wrong/num`, params)
// 题库题目详情
const getQuestion = (params) => apiGet(`/api/question/bank/detail/${params.questionId}`, params)
// 题库题目用户作答
const postDaily = (params) => apiPost(`/api/question/bank/user`, params)

const getIsCorrect = (params) => apiGet(`/api/question/bank/user/isCorrect/${params.userId}/${params.questionId}`, params)

// 查询题库题目及序号列表
const getTopicNumber = (params) => apiGet(`/api/question/user/bank/topic/${params.classCode}/${params.difficultyLevel}`, params)
// 题目收藏
const postCollect = (params) => apiPost(`/api/question/user/collect`, params)
// 题目取消收藏
const delCollect = (params) => apiPost(`/api/question/user/collect/cancellation`, params)
// 用户题库分类等级答题统计
const getClassStat = (params) => apiGet(`/api/question/user/class/stat/${params.classCode}/${params.difficultyLevel}`, params)
// 错题库序号列表
const getWrongStat = (params) => apiGet(`/api/question/user/result/wrong/${params.classCode}/${params.difficultyLevel}`, params)
// 收藏序号列表
const getCollectStat = (params) => apiGet(`/api/question/user/collect/serial/${params.classCode}/${params.difficultyLevel}`, params)
// 判新病种等级是否解锐
const getUnlock = (params) => apiGet(`/api/question/bank/unlock/${params.iepUserId}/${params.classCode}/${params.difficultyLevel}`)
// 问题列表
const getQuestionList = (params) => apiGet(`/api/question/user/bank/topic/detail/${params.classCode}/${params.difficultyLevel}/${params.type}`)

// 获取解锁的顺序
const getUnlockNum = (params) => apiGet(`/api/question/bank/unlock/rank/${params.classCode}/${params.difficultyLevel}`, params)

// 获取用户答题状态
const getQuestionUserStatus = (params) => apiGet(`/api/question/user/result/status/${params.userId}/${params.questionId}`)

export {
  dailyStatistics,
  dailyQuestionRemind,
  updateDailyQuestionRemind,
  dailyRead,
  postDailyRead,
  getEffective,
  getLevel,
  getBankList,
  getTopicList,
  getCollectBankList,
  getCollectTopicList,
  getErrBankList,
  getErrTopicList,
  delWrong,
  getQuestion,
  postDaily,
  getIsCorrect,
  getTopicNumber,
  postCollect,
  delCollect,
  getClassStat,
  getWrongStat,
  getCollectStat,
  getUnlock,
  getQuestionList,
  getUnlockNum,
  getQuestionUserStatus
}



// WEBPACK FOOTER //
// ./src/api/questionBank.js